import NoResults from '@/components/table/noResults';
import { TransformedAssetClassForecastValueDto } from '../../../../types';
import TableRow from './tableRow';

interface TableBodyProps {
  tableData: TransformedAssetClassForecastValueDto[];
  columnWidth: number;
  targetSubAssetClasses: boolean;
}

const TableBody = ({ tableData, columnWidth, targetSubAssetClasses }: TableBodyProps) => {
  if (!tableData?.length) {
    return <NoResults />;
  }

  return (
    <>
      {tableData.map((row) => (
        <TableRow key={row.name} row={row} columnWidth={columnWidth} targetSubAssetClasses={targetSubAssetClasses} />
      ))}
    </>
  );
};

export default TableBody;
